import { Grid as MuiGrid } from '@mui/material';

import { BasetenPageEnum } from '@/routes';

import GridCardWrapper from '../../sections/GridCardWrapper';
import { GridContainer } from '../../styled';
import { ListProps } from '../types';
import Card from './Card';

function Grid({ chains }: ListProps) {
  return (
    <GridContainer px={4} py={2}>
      <MuiGrid container spacing={3}>
        {chains.map((chain) => (
          <GridCardWrapper<BasetenPageEnum.Chain>
            linkParams={{ page: BasetenPageEnum.Chain, params: { chainId: chain.id } }}
            key={chain.id}
            alwaysVisible={chains.length < 35}
          >
            <Card chain={chain} />
          </GridCardWrapper>
        ))}
      </MuiGrid>
    </GridContainer>
  );
}

export default Grid;
